import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import {listRelationships} from '../utils/utilsLogicalModel';

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';

class ListRelationships extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Relationships : null
        };

        this.dsd = new dsd();

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }

}

loadData(filters){

    const onLoad = function(arr){
        this.setState({
            Relationships: arr,
            renderState: 'loaded'
        });
        
        // Call parent's onLoad callback if provided
        if (this.state.onLoad){
            this.state.onLoad(arr.length);
        }
    }.bind(this);

    const onError = function(e){
        this.setState({
            renderState: 'failed',
            errorMessage: e.message
        });
    }.bind(this);

    listRelationships(this.dsd, filters, onLoad, onError);
}

setup(){

    let StateChange = {
        filters: {},
        columns: {
            owner:false,
            logicalmodel: false
        },
        onLoad: null,
        renderState: 'loading'
    };

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }


    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    this.setState(StateChange);

    this.loadData(StateChange.filters);
        
}



    included(Relationship) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    A problem has occurred
                </PD.ErrorBox>
            )
        }


        if (this.state.renderState === 'loaded') {
            let arrRelationships = this.state.Relationships;
            if (isArray(arrRelationships)){
                if (arrRelationships.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>From Entity</PD.Th>
                                    <PD.Th>Link</PD.Th>
                                    <PD.Th>To Entity</PD.Th>

                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.logicalmodel &&
                                        <PD.Th>Logical Model</PD.Th>                            
                                    }

                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrRelationships.map(
                                    (Relationship, pos) => 
                                    {
                                        if (this.included(Relationship)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            {Relationship.EntityFrom.name}
                                                        </PD.Td>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/relationship/" + Relationship._id} > {Relationship.label}</PD.PdNavLink>
                                                        </PD.Td>
                                                        <PD.Td>
                                                            {Relationship.EntityTo.name}
                                                        </PD.Td>
                                                        <PD.Td/>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Relationship.LogicalModel){
                                                                        if (Relationship.LogicalModel.Owner){
                                                                            return Relationship.LogicalModel.Owner.organisation;
                                                                        }
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.logicalmodel &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Relationship.LogicalModel){
                                                                        return Relationship.LogicalModel.name;
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Relationship.description, 400)}</PD.MdPresent>
                                                        </PD.Td>
                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListRelationships_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListRelationships {...props} navigation={navigation} location={location} params={params} />;
  }
